import React, { useState, useEffect } from 'react';
import { pushValueString, pushSelectedChipArray } from '../../slices/RiskFilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import TableFunction from '../../component/Application/RecommendationTable/TableFunction';
import { Styles } from '../../component/Application/RecommendationTable/TableStyling';
import { TablePagination } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { getRiskAPIResponseData } from '../../services/apiservices';
import { pushCheckBoxShowLoading } from '../../slices/SpinnerSlice';
import { getFilterUrl } from '../../utils/utils';
export const StyledSpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledDataDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TablePaginationComponent = withStyles({
  select: {
    border: '1px solid #ADADAD',
    borderRadius: '2px'
  }
})(TablePagination);

const CheckboxValueCard = ({
  filterValueCardData,
  type,
  paginationData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  match,
  searchUpdatedpage,
  setSearchPage,
  searchRowsPerPage,
  setSearchRowsPerPage
}) => {
  const filterQueryArray = useSelector(state => state.riskFilterSlice.filterQueryArray);
  const chipArray = useSelector(state => state.riskFilterSlice.chipArray);
  const searchChipArray = useSelector(state => state.riskFilterSlice.searchChipArray);
  const searchString = useSelector(state => state.riskFilterSlice.searchString);
  const searchResponse = useSelector(state => state.recommendationTable.search);
  const {
    data = {}
  } = searchString.length > 0 && searchResponse ? searchResponse || {} : paginationData || {};
  const {
    pageNumber = 0,
    totalElements = 0
  } = data || {};
  const dispatch = useDispatch();

  const generateData = type => {
    let columns = [];
    let rows = [];
    var filteredArray = filterValueCardData.filter(value => Object.keys(value).length !== 0);

    switch (type) {
      case 'Application Name':
        {
          columns = [{
            accessor: 'Application_Name',
            Header: 'Application Name',
            width: 130
          }];
          rows = filteredArray.map((cardData, index) => ({
            id: index,
            Application_Name: cardData.appName,
            checked: false
          }));
          return {
            rows,
            columns
          };
        }

      case 'Application Type':
        {
          columns = [{
            accessor: 'Application_Type',
            Header: 'Application Type',
            width: 130
          }];
          rows = filteredArray.map((cardData, index) => ({
            id: index,
            Application_Type: cardData.appType,
            checked: false
          }));
          return {
            rows,
            columns
          };
        }

      case 'Environment Name':
        {
          columns = [{
            accessor: 'Environment_Name',
            Header: 'Environment Name',
            width: 130
          }];
          rows = filteredArray.map((cardData, index) => ({
            id: index,
            Environment_Name: cardData.envName,
            checked: false
          }));
          return {
            rows,
            columns
          };
        }

      case 'Entity Type':
        {
          columns = [{
            accessor: 'Entity_Type',
            Header: 'Entity Type',
            width: 130
          }];
          rows = filteredArray.map((cardData, index) => ({
            id: index,
            Entity_Type: cardData.objectType === 'UserAccount' ? 'User Account' : cardData.objectType,
            checked: false
          }));
          return {
            rows,
            columns
          };
        }

      case 'Entity Name':
        {
          columns = [{
            accessor: 'Entity_Name',
            Header: 'Entity Name',
            width: 130
          }];
          rows = filteredArray.map((cardData, index) => ({
            id: index,
            Entity_Name: cardData.objectName,
            checked: false
          }));
          return {
            rows,
            columns
          };
        }

      default:
        break;
    }
  };

  const handleChangePage = (event, newPage) => {
    if (searchResponse && searchResponse.data) {
      setSearchPage(newPage);
    } else {
      setPage(newPage);
    }
  };

  const handleChangeRowsPerPage = event => {
    if (searchResponse && searchResponse.data) {
      setSearchPage(0);
      setSearchRowsPerPage(parseInt(event.target.value, 10));
    } else {
      setPage(0);
      setRowsPerPage(parseInt(event.target.value, 10));
    }
  };

  const [checkListArray, setCheckListArray] = useState([]);
  const [searchArray, setSearchArray] = useState([]);
  useEffect(() => {
    let keyName = type && type.keyName;
    let selectedChecListArray = generateData(keyName).rows;
    setCheckListArray(selectedChecListArray);
  }, [type, filterValueCardData]);
  useEffect(() => {
    if (chipArray && chipArray.length > 0) setCheckListArray(chipArray);
  }, [chipArray]);
  useEffect(() => {
    if (searchChipArray && searchChipArray.length > 0) setSearchArray(searchChipArray);
  }, [searchChipArray]);
  useEffect(() => {
    let chipArray = [];
    let truthyArray = [];
    let entityKeyName = type && type.keyName;
    truthyArray = checkListArray.filter(checkedItem => {
      return checkedItem.checked;
    });
    let truthyName = truthyArray.map(item => {
      let selectedName = '';

      switch (entityKeyName) {
        case 'Application Name':
          {
            selectedName = item.Application_Name;
            break;
          }

        case 'Application Type':
          {
            selectedName = item.Application_Type;
            break;
          }

        case 'Environment Name':
          {
            selectedName = item.Environment_Name;
            break;
          }

        case 'Entity Type':
          {
            selectedName = item.Entity_Type;
            break;
          }

        case 'Entity Name':
          {
            selectedName = item.Entity_Name;
            break;
          }

        default:
          break;
      }

      return selectedName;
    });
    let selectedArray = truthyName.join(' ');
    dispatch(pushValueString(selectedArray));
    truthyName.forEach(element => {
      chipArray.push(filterQueryArray[0] + ' ' + filterQueryArray[1] + ' ' + element);
    });
    dispatch(pushSelectedChipArray(chipArray));
  }, [checkListArray, filterQueryArray]);
  useEffect(() => {
    let rows = '';
    let data = [];

    if (searchResponse && searchResponse.data) {
      data = searchResponse.data.responseList;
      dispatch(pushCheckBoxShowLoading(false));
    }

    let keyName = type && type.keyName;

    switch (keyName) {
      case 'Application Name':
        {
          rows = data.map((cardData, index) => {
            return {
              id: index,
              Application_Name: cardData.appName,
              checked: false
            };
          });
          break;
        }

      case 'Application Type':
        {
          rows = data.map((cardData, index) => {
            return {
              id: index,
              Application_Type: cardData.appType,
              checked: false
            };
          });
          break;
        }

      case 'Environment Name':
        {
          rows = data.map((cardData, index) => {
            return {
              id: index,
              Environment_Name: cardData.envName,
              checked: false
            };
          });
          break;
        }

      case 'Entity Type':
        {
          rows = data.map((cardData, index) => {
            return {
              id: index,
              Entity_Type: cardData.objectType,
              checked: false
            };
          });
          break;
        }

      case 'Entity Name':
        {
          rows = data.map((cardData, index) => {
            return {
              id: index,
              Entity_Name: cardData.objectName,
              checked: false
            };
          });
          break;
        }

      default:
        break;
    }

    if (rows && rows.length > 0 && searchString.length > 0) {
      setSearchArray(rows);
    } else {
      setSearchArray([]);
    }
  }, [searchResponse]);
  useEffect(() => {
    let url = '';
    let keyName = type && type.keyName;
    let searchType = keyName === 'Application Name' ? 'appName' : keyName === 'Application Type' ? 'appType' : keyName === 'Environment Name' ? 'envName' : keyName === 'Entity Type' ? 'objectType' : keyName === 'Entity Name' ? 'objectName' : null;
    let filterValue = '';

    if (searchString.length >= 1) {
      let obj = {
        searchType,
        limit: searchRowsPerPage,
        offsetValue: searchUpdatedpage
      };
      filterValue += `${searchType}:c:${searchString},recoType=any`;

      if (!match.params.appName) {
        obj.filterValue = filterValue;
      } else if (match.params.appName && match.params.appName.length > 0 && !match.params.envName) {
        filterValue += `origin=${match.params.appName},recoType=any`;
        obj.filterValue = filterValue;
      } else if (match.params.envName && match.params.envName.length > 0) {
        filterValue += `origin=${match.params.appName},envName=${match.params.envName},recoType=any`;
        obj.filterValue = filterValue;
      }

      url = getFilterUrl(obj);
      dispatch(getRiskAPIResponseData(url, 'search'));
      dispatch(pushCheckBoxShowLoading(true));
    }
  }, [searchRowsPerPage, searchUpdatedpage]);
  let displatData = searchResponse && searchString.length >= 1 ? searchArray : checkListArray;
  const spinnerStatus = useSelector(state => state.spinner.checkBoxLoading);
  let rowsPerPageFinal = searchArray.length > 0 && searchResponse ? searchRowsPerPage : rowsPerPage;
  return /*#__PURE__*/React.createElement(React.Fragment, null, spinnerStatus ? /*#__PURE__*/React.createElement(StyledSpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, displatData.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styles, null, /*#__PURE__*/React.createElement(TableFunction, {
    columns: generateData(type.keyName).columns,
    data: displatData,
    "min-width": "30px",
    checkListArray: checkListArray,
    searchResponse: searchArray
  })), /*#__PURE__*/React.createElement(TablePaginationComponent, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: totalElements,
    page: pageNumber,
    labelDisplayedRows: ({
      page,
      count
    }) => `Page ${page + 1} of  ${Math.ceil(count / rowsPerPageFinal) != 0 ? Math.ceil(count / rowsPerPageFinal) : 1}`,
    rowsPerPage: rowsPerPageFinal,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })) : /*#__PURE__*/React.createElement(StyledDataDiv, null, "No Data !!!")));
};

export default withRouter(CheckboxValueCard);